function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512px",
    height: "512px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.972
    },
    fill: "#858585",
    d: "M 120.5,85.5 C 130.873,85.5906 137.373,90.5906 140,100.5C 140.667,203.833 140.667,307.167 140,410.5C 135.663,423.917 126.83,428.083 113.5,423C 110.238,420.408 107.738,417.241 106,413.5C 105.333,308.167 105.333,202.833 106,97.5C 108.964,91.0186 113.797,87.0186 120.5,85.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.972
    },
    fill: "#858585",
    d: "M 385.5,85.5 C 394.926,84.8029 401.426,88.8029 405,97.5C 405.667,202.833 405.667,308.167 405,413.5C 401.811,421.024 396.144,425.024 388,425.5C 378.614,424.65 372.947,419.65 371,410.5C 370.333,307.167 370.333,203.833 371,100.5C 372.681,92.3207 377.514,87.3207 385.5,85.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.971
    },
    fill: "#868686",
    d: "M 64.5,135.5 C 75.6539,133.819 83.1539,138.152 87,148.5C 87.6667,219.833 87.6667,291.167 87,362.5C 81.097,376.021 71.597,379.188 58.5,372C 56.0439,369.592 54.2106,366.759 53,363.5C 52.3333,291.5 52.3333,219.5 53,147.5C 55.0451,141.624 58.8785,137.624 64.5,135.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.971
    },
    fill: "#868686",
    d: "M 170.5,135.5 C 176.602,134.733 182.269,135.899 187.5,139C 190.231,141.626 192.064,144.793 193,148.5C 193.667,219.833 193.667,291.167 193,362.5C 189.162,373.007 181.662,377.173 170.5,375C 164.269,373.037 160.436,368.87 159,362.5C 158.333,291.167 158.333,219.833 159,148.5C 160.589,142.083 164.423,137.749 170.5,135.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.971
    },
    fill: "#868686",
    d: "M 329.5,135.5 C 340.654,133.819 348.154,138.152 352,148.5C 352.667,219.833 352.667,291.167 352,362.5C 346.134,375.999 336.634,379.166 323.5,372C 320.769,369.374 318.936,366.207 318,362.5C 317.333,291.167 317.333,219.833 318,148.5C 319.589,142.083 323.423,137.749 329.5,135.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.971
    },
    fill: "#868686",
    d: "M 435.5,135.5 C 446.4,133.394 453.9,137.394 458,147.5C 458.667,219.5 458.667,291.5 458,363.5C 453.902,373.767 446.402,377.6 435.5,375C 429.269,373.037 425.436,368.87 424,362.5C 423.333,291.167 423.333,219.833 424,148.5C 425.589,142.083 429.423,137.749 435.5,135.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.969
    },
    fill: "#868686",
    d: "M 280.5,161.5 C 289.761,161.539 295.928,165.872 299,174.5C 299.667,228.5 299.667,282.5 299,336.5C 296.255,344.571 290.588,348.904 282,349.5C 273.006,348.837 267.339,344.17 265,335.5C 264.333,282.167 264.333,228.833 265,175.5C 267.242,167.417 272.409,162.751 280.5,161.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.969
    },
    fill: "#868686",
    d: "M -0.5,314.5 C -0.5,275.167 -0.5,235.833 -0.5,196.5C 4.37693,186.234 12.3769,182.734 23.5,186C 30.0531,188.601 33.5531,193.434 34,200.5C 34.6667,237.167 34.6667,273.833 34,310.5C 32.4914,320.507 26.6581,325.84 16.5,326.5C 8.08388,326.146 2.41721,322.146 -0.5,314.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.969
    },
    fill: "#868686",
    d: "M 511.5,196.5 C 511.5,235.833 511.5,275.167 511.5,314.5C 506.623,324.766 498.623,328.266 487.5,325C 480.947,322.399 477.447,317.566 477,310.5C 476.333,273.833 476.333,237.167 477,200.5C 479.241,188.621 486.407,183.454 498.5,185C 504.942,186.617 509.275,190.45 511.5,196.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.969
    },
    fill: "#868686",
    d: "M 222.5,188.5 C 234.318,186.024 242.151,190.357 246,201.5C 246.667,237.5 246.667,273.5 246,309.5C 240.64,322.404 231.473,325.904 218.5,320C 215.131,317.635 212.964,314.468 212,310.5C 211.333,273.833 211.333,237.167 212,200.5C 213.936,195.068 217.436,191.068 222.5,188.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundGrey);
export default __webpack_public_path__ + "static/media/soundGrey.bd1a993f98092c8b348f0f752f5e07c1.svg";
export { ForwardRef as ReactComponent };